import { render } from "./FilterPanel.vue?vue&type=template&id=22019a00&scoped=true"
import script from "./FilterPanel.vue?vue&type=script&lang=js"
export * from "./FilterPanel.vue?vue&type=script&lang=js"

import "./FilterPanel.vue?vue&type=style&index=0&id=22019a00&scoped=true&lang=css"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22019a00"]])

export default __exports__